import { Component, Input, OnInit } from '@angular/core';
import { StatusDocumentoAssinatura } from 'src/app/pages/call-center/pages/projects/models/status-documento';
import { AssinarDocumentoService } from 'src/app/pages/call-center/pages/projects/services/assinar-documento.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-documento-enviado',
  templateUrl: './documento-enviado.component.html',
  styleUrl: './documento-enviado.component.scss'
})
export class DocumentoEnviadoComponent {
  @Input() documento: StatusDocumentoAssinatura = {};

  constructor(private assinarDocumentoService: AssinarDocumentoService, private toastService: ToastService) { }

  baixarDocumento(documentoUuId: string) {
    this.assinarDocumentoService.downloadDocumentoSimplificado(documentoUuId).subscribe(response => {
      const url = response.url;

      // Cria um link invisível para forçar o download
      const a = document.createElement('a');
      a.href = url;
      a.download = ''; // opcional: pode definir nome, ex: 'documento.pdf'
      a.click();
    });
    this.timer();
  }

  // Apresenta modal de timer de download
  timer() {
    let timerInterval: any;
    Swal.fire({
      title: 'Seu download Esta sendo preparado!',
      html: 'Não mude de tela, aguarde o download iniciar.',
      timer: 5500,
      timerProgressBar: true,
      didOpen: () => {
        timerInterval = setInterval(() => {
          const content = Swal.getHtmlContainer();
          if (content) {
            const b: any = content.querySelector('b');
            if (b) {
              b.textContent = Swal.getTimerLeft();
            }
          }
        }, 100);
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  }

  /// Modal canelar documento
  /// @param id - ID do contato a ser deletado (opcional)
  cancelarDocumentoClick(documentoUuId?: string) {
    this.cancelarDocumento(documentoUuId);
  }


  private cancelarDocumento(documentoUuId?: string) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Continuar e Cancelar?',
        text: 'O documento será cancelado!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, continuar!',
        cancelButtonText: 'Não cancelar!'
      })
      .then(result => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Cancelado!',
            'Seu documento foi cancelado.',
            'success'
          );

          this.assinarDocumentoService.cancelarDocumento(documentoUuId!).subscribe(
            response => {
              this.toastService.show("Documento cancelado com sucesso!", {
                classname: "bg-success text-light",
              });
            },
            error => {
              const _erro = `Erro ao cancelar documento! ${documentoUuId}`;
              this.toastService.show(_erro, {
                classname: "bg-danger text-light",
              });
            }
          );

        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelado',
            'Seu documento foi cancelado.',
            'error'
          );
        }
      });
  }
}
